import { h } from 'preact'
import {emojify} from 'react-emojione-preact'
import style from './styles/response.scss'

const Response = ({answer}) => (
  <div class={style.normal}>
    <p class={style.text}>{emojify(answer, {style: {height: 20}})}</p>
  </div>
)

export default Response



// WEBPACK FOOTER //
// ./components/ChatBot/Response.js